import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';

@Component({
  selector: 'app-reward-create',
  templateUrl: './reward-create.component.html',
  styleUrls: ['./reward-create.component.scss']
})
export class RewardCreateComponent implements OnInit {
  imageFile:any = ''
  ThumbnailFile:any = ''
  formGroup:any
  imagename: any = 'Choose File'
  thumbnailname: any = 'Choose File'
  submitted:boolean = false 
  convertedBase64Image: string | null = null;
  convertedBase64Thumbnail: string | null = null;

  @Output() rewardCreated:EventEmitter<boolean> = new EventEmitter
  @Output() rewardCreatedID:EventEmitter<any> = new EventEmitter
  rewardID: any;

  constructor(
    private fb : FormBuilder,
    private apiService : ApiService,
    private apiConfig : ApiConfiguration,
    private http : HttpClient,
    private toast : ToastClientService,
    private activateRoute : ActivatedRoute 
    ) { }

  ngOnInit() {
    this.FormControl()
    this.activateRoute.params.subscribe((res:any)=>{
      console.log(res.rewardID)
      this.rewardID = res.rewardID
      if(res.rewardID != 0){
        this.getRewardDetailsOnID(res.rewardID)
      }
    })
  }


  FormControl(){
    this.formGroup = this.fb.group({
      reward_name : new FormControl('',Validators.required),
      short_description : new FormControl('',Validators.required),
      description : new FormControl('',Validators.required),
      success_msg : new FormControl('',Validators.required),
      image : new FormControl('',Validators.required),
      thumbnail : new FormControl('',Validators.required),
    })
  }

  get f(){
    return this.formGroup.controls
  }



  onSubmit(formvalue){
    this.submitted = true
    if(this.formGroup.invalid){
      return
    }
    console.log(formvalue)
    
    const formData = new FormData()
    formData.append("reward_name",formvalue.reward_name)
    formData.append("short_desc",formvalue.short_description)
    formData.append("desc",formvalue.description)
    formData.append("succes_msg",formvalue.success_msg)
    formData.append("image",this.imageFile)
    formData.append("thumbnail",this.ThumbnailFile)

    // For Update
    if(this.rewardID != 0){
      formData.append("id",this.rewardID)
    }

    this.apiService.upload1(this.apiConfig.createReward,formData).subscribe((res:any)=>{
      try{
        console.log(res)
        if(res.status==200){
          this.rewardCreated.emit(true)
          this.rewardCreatedID.emit(res.body.data.id)
          this.toast.Success(res.body.data.message)
        }
      }catch{
        
      }
    }),err=>{
        this.toast.Error("Error")
    }

  }

  getRewardDetailsOnID(id){
    this.apiService.get(this.apiConfig.getRewardlist + `?id=${id}&search=`).subscribe((res:any)=>{
      console.log(res.data.details)
      this.imageFile = res.data.details[0].img
      this.ThumbnailFile = res.data.details[0].thumbnail
      this.convertedBase64Image = res.data.details[0].img
      this.convertedBase64Thumbnail = res.data.details[0].thumbnail
      this.formGroup.controls['image'].clearValidators()
      this.formGroup.controls['image'].updateValueAndValidity();
      this.formGroup.controls['thumbnail'].clearValidators()
      this.formGroup.controls['thumbnail'].updateValueAndValidity()
      this.patchValue(res.data.details[0])
    })
  }

  patchValue(data){
    this.formGroup.patchValue({
      reward_name : data.reward_name,
      short_description : data.short_desc ,
      description : data.description,
      success_msg : data.success_msg,
    })
  }

  selectedImage(event: any,type): void {
    if(type == "image"){
      this.imagename = event.target.files[0].name
      this.imageFile = event.target.files[0]
      if (this.imageFile) {
        this.convertToBase64(this.imageFile,type);
      }
    }
    if(type == 'thumbnail'){
      this.thumbnailname = event.target.files[0].name
      this.ThumbnailFile = event.target.files[0]
  
      if (this.ThumbnailFile) {
        this.convertToBase64(this.ThumbnailFile,type);
      }
    }
  }

  convertToBase64(file: File,type:any): void {
    const reader = new FileReader();
    if(type == "image"){
      reader.onloadend = () => {
        // The result property contains the Base64-encoded image
        this.convertedBase64Image = reader.result as string;
      };
    }
    if(type == "thumbnail"){
      reader.onloadend = () => {
        // The result property contains the Base64-encoded image
        this.convertedBase64Thumbnail = reader.result as string;
      }; 
    }
    // Read the image as Data URL
    reader.readAsDataURL(file);
  }
}




